import { motion } from "framer-motion";
import { Instagram, MapPin, Heart } from "lucide-react";
import { fadeUp } from "./motion";
import { LOCATIONS, ASSETS, IG_URL, openOrder } from "../../data/site";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#2A1620] text-white">
      {/* CTA band */}
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 sm:py-20 border-b border-white/10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="font-display text-[clamp(2rem,6vw,4.5rem)] leading-[1]">
            Come get it <span className="font-script text-[#F9A8CB]">rolled</span>
          </motion.h2>
          <div className="flex flex-col sm:flex-row gap-3">
            <button onClick={openOrder} data-testid="footer-order"
              className="btn-primary text-center px-10 py-5 text-sm font-bold uppercase tracking-[0.12em]">Order Online</button>
            <button onClick={() => scrollTo("locations")} data-testid="footer-locations"
              className="rounded-full border-2 border-white/70 hover:bg-white hover:text-[#2A1620] transition-colors px-10 py-5 text-sm font-bold uppercase tracking-[0.12em]">
              Find a Location
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img src={ASSETS.logoWhite} alt="Rock N Roll Hand Rolled Premium Ice Cream" className="h-20 w-20 object-contain" />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">Hand rolled premium ice cream, made fresh to order across California's Central Valley.</p>
          <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[#F63C8B] px-3.5 py-1.5 text-white text-[11px] font-bold uppercase tracking-[0.14em]">
            <Heart size={12} className="fill-white" /> Proudly Women Owned
          </span>
          <div className="mt-4 space-y-1 text-sm text-white/80">
            <a href="tel:2097992999" className="link-underline block">(209) 799-2999</a>
            <a href="mailto:info@rocknroll.llc" className="link-underline block">info@rocknroll.llc</a>
          </div>
          <div className="flex gap-3 mt-6">
            <a href={IG_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="grid place-items-center h-10 w-10 rounded-full border border-white/20 hover:bg-[#F63C8B] hover:border-[#F63C8B] transition-colors"><Instagram size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F9A8CB] mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-white/80">
            {["menu", "story", "shakes", "gallery"].map((id) => (
              <li key={id}><button onClick={() => scrollTo(id)} className="link-underline capitalize">{id === "story" ? "Our Story" : id}</button></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F9A8CB] mb-4">Locations</h4>
          <ul className="space-y-2.5 text-sm text-white/80">
            {LOCATIONS.map((l) => (
              <li key={l.city} className="flex items-center gap-2"><MapPin size={13} className="text-[#12B99B]" /> {l.city}, {l.state}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F9A8CB] mb-4">Every Cup</h4>
          <p className="font-display text-5xl text-[#F9A8CB]">$10</p>
          <p className="mt-2 text-sm text-white/60">3 complimentary toppings + unlimited drizzles, always included.</p>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50 uppercase tracking-[0.12em]">
          <span>© {new Date().getFullYear()} Rock N Roll Hand Rolled Ice Cream</span>
          <span>Made fresh in California</span>
        </div>
      </div>
    </footer>
  );
};
